import { render, staticRenderFns } from "./RatesOverview.vue?vue&type=template&id=2fe6fdd9&scoped=true"
import script from "./RatesOverview.vue?vue&type=script&lang=js"
export * from "./RatesOverview.vue?vue&type=script&lang=js"
import style0 from "./RatesOverview.vue?vue&type=style&index=0&id=2fe6fdd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6fdd9",
  null
  
)

export default component.exports